module.exports = __webpack_public_path__ + "static/WA-e44fc3f075c4fed5510046054a0d4c03.svg";